//Seite fiddle

import React from "react"
import Gallery from "react-grid-gallery";

import twomen from "../images/fiddles/2_men.png"
import cave from "../images/fiddles/cave.png"
import dtme from "../images/fiddles/dtn.png"
import face from "../images/fiddles/face.png"
import kunst from "../images/fiddles/Kunst.png"


import { Container, Row, Col } from "react-bootstrap";
const w = 400;
const h = 400;


const IMAGES = [
  {
    src: twomen,
    thumbnail:
      twomen,
    thumbnailWidth: w,
    thumbnailHeight: h,
    caption: "romantic"
  },

  {
    src: cave,
    thumbnail:
      cave,
    thumbnailWidth: w,
    thumbnailHeight: h,
    caption: "cave face"
  },
  {
    src: dtme,
    thumbnail:
      dtme,
    thumbnailWidth: w,
    thumbnailHeight: h,
    caption: "angry"
  },
  {
    src: face,
    thumbnail:
      face,
    thumbnailWidth: w,
    thumbnailHeight: h,

    caption: "idle"
    
  },

  {
    src: kunst,
    thumbnail:
      kunst,
    thumbnailWidth: w,
    thumbnailHeight: h,
    caption: "grandma"
  },

];


const Fiddle = () => {
  return (
    <>
      <Container>
        <Row>
          <Col><p >Just lines <br></br>Nothing more</p> 
          </Col>
          <Col> <div>
            <Gallery
              images={IMAGES}
              enableLightbox={true}
              backdropClosesModal
            />
          </div>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </>
  )
}

export default Fiddle
